import { useCommunicationNewProducts } from '@benefits/common-services';
import { Dashboard } from '@benefits/router-services';
import Router from 'next/router';
import { useEffect } from 'react';

import { SAFE_ROUTES } from '../Auth/Auth.routes';

const CommunicationNewProductsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { showCommunication } = useCommunicationNewProducts();

  const currentUrl = Router.pathname;

  useEffect(() => {
    const blackListUrls: string[] = [
      Dashboard.WELCOME,
      Dashboard.HR_AREA_PRESENTATION,
      Dashboard.SETUP,
      ...SAFE_ROUTES,
    ];

    if (showCommunication && !blackListUrls.includes(currentUrl)) {
      Router.push(Dashboard.DASHBOARD);
    }
  }, [currentUrl, showCommunication]);

  return <>{children}</>;
};

export default CommunicationNewProductsProvider;
